// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__udPF3","name":"Header_name__2UxM5","birthday":"Header_birthday__2j8DV","skeleton":"Header_skeleton__3MgqK"};